import { useQuery } from "@tanstack/react-query";
import api from "./api";

async function getBranches() {
  try {
    var response = await api.get("api/branches");
    return response.data;;
  } catch (error) {
    return false;
  }
}

function useBranches() {
  return useQuery({
    queryKey: ["branches"],
    queryFn: getBranches,
    staleTime: 60_000,
    select: (data) => Array.isArray(data) ? data : [],
  });
}

export {
  getBranches,
  useBranches,
};
